import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { WorkOrder } from '../WorkOrder'
import { SerialNumberInput } from '../../inventorybyserialnumber/args/UpdateProductInventoryWithSerialNumbersArgs'

@InputType()
export class FulfillWorkOrderArgs extends ActionArgs {
  @Field(() => ID)
  workOrderId: string

  @Field(() => String)
  remarks?: string

  @Field(() => [String])
  tags?: string[]

  @Field(() => [SerialNumberInput], { nullable: true })
  inventoryBySerialNumbers?: SerialNumberInput[]
}

export interface IFulfillWorkOrder extends IAction<WorkOrder, FulfillWorkOrderArgs> {}
